import React, { useEffect, useState,useRef } from "react";
import { Modal, Flex, Table, Typography, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
import commonFn from "@/utils/commonFn";

const { Title } = Typography;

const DetailsModal = ({
  visible,
  onCancel,
  currentRecordId,
}) => {
  const [tableLoading, setTableLoading] = useState(false);
  const [detailsListData, setDetailsListData] = useState([]);
const currentRecordIdRef = useRef(currentRecordId);
const [tableKey, setTableKey] = useState(0);
const initTableHead = {
  vendorName: null,
  vpStatus: null,
  requestNumber: null,
  payAmount: null,
  requestDate: null,
  requestStatus: null,
  jobType: null,
  supervisor: null,
  materialAmount: null,
};

const [tableHead, setTableHead] = useState(initTableHead);
const handleSearchInput = (key) => (e) => {
  if (e.key === "Enter") {
    e.preventDefault();
    e.stopPropagation();
    const inputValue = e.target.value;
    setTableHead((prev) => ({
      ...prev,
      [key]: inputValue,
    }));
    getTableListFn(currentRecordIdRef.current, { [key]: inputValue });
  }
};

  // 详情搜索处理
  // 详情列定义
  const initOtherColumns = [
    {
      title: "Vendor",
      dataIndex: "vendorName",
      key: "vendorName",
       titleType: "Input",
      width: 100,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
    onChange: handleSearchInput("vendorName"),
    },
    {
      title: "Status",
      dataIndex: "vpStatus",
      key: "vpStatus",
       titleType: "Input",
      hidden: false,
      width: 100,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
        onChange: handleSearchInput("vpStatus"),
    },
    {
      title: "Request Number",
      dataIndex: "requestNumber",
      key: "requestNumber",
       titleType: "Input",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
         onChange: handleSearchInput("requestNumber"),
    },
    {
      title: "Pay Amount",
      dataIndex: "payAmount",
      key: "payAmount",
       titleType: "Input",
      hidden: false,
      width: 120,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
     render: commonFn.amountToDollarFn,
         onChange: handleSearchInput("payAmount"),
    },
    {
      title: "Request Date",
      dataIndex: "requestDate",
      key: "requestDate",
       titleType: "DatePicker",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 3,
      render: (text, record, index) =>
        text ? moment(text).format("MM/DD/YYYY ") : " ",
          onChange: (e) => handleSearchInput(e, "DatePicker", "DatePicker"),
    },
    {
      title: "Request Status",
      dataIndex: "requestStatus",
      key: "requestStatus",
       titleType: "Input",
      hidden: false,
      width: 150,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      onChange: handleSearchInput("requestStatus"),
    },
    {
      title: "Job Type",
      dataIndex: "jobType",
      key: "jobType",
       titleType: "Input",
      hidden: false,
      width: 100,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
    onChange: handleSearchInput("jobType"),
    },
    {
      title: "Supervisor",
      dataIndex: "supervisor",
      key: "supervisor",
       titleType: "Input",
      hidden: false,
      width: 100,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
    onChange: handleSearchInput("supervisor"),
    },
    {
      title: "Need Material",
      dataIndex: "needMaterial",
      key: "needMaterial",
       titleType: "Input",
      hidden: false,
      width: 150,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
     onChange: handleSearchInput("needMaterial"),
    },
    {
      title: "Material $",
      dataIndex: "materialAmount",
      key: "materialAmount",
       titleType: "Input",
      hidden: false,
      width: 100,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
        onChange: handleSearchInput("materialAmount"),
    },
  ];

  const [othercolumns] = useState(commonFn.handleColunmFn(initOtherColumns));
  const handleCancel = () => {
    setTableHead(initTableHead);
  setTableKey(prev => prev + 1)
    onCancel();
  };
  // 获取详情数据
  const getTableListFn = async (id,tableHead = {}) => {
    setTableLoading(true);
 const params = {
    id: id ||currentRecordId,
    ...Object.entries(tableHead).reduce((acc, [key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        acc[key] = value;
      }
      return acc;
    }, {}),
  };

    try {
      const response = await http.get(api.getShowDetail, { params });
      if (response.code === "1") {
        const dataWithKey = (response.data || []).map((item) => ({
          ...item,
          key: item.id,
        }));
        setDetailsListData(dataWithKey);
        setTableLoading(false);
      } else {
        message.error(response.msg);
      }
    } catch (error) {
      message.error("Request failed.");
    } finally {
      setTableLoading(false);
    }
  };


  useEffect(() => {
    if (visible && currentRecordId) {
      getTableListFn(currentRecordId);
    }
  }, [visible, currentRecordId]);
useEffect(() => {
  currentRecordIdRef.current = currentRecordId;
}, [currentRecordId]);
  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Title level={4} className="mg">
            DETAILS
          </Title>
        </Flex>
      }
      width="80%"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      styles={{
    content: {
      backgroundColor: "#F5F6ED",
    },
    body: {
      height: "80vh",
      padding: "16px 24px",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
    },
    header: {
      backgroundColor: "#F5F6ED",
      borderBottom: "1px solid #d4d2d2ff", 
    }
  }}
>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          background: "#F5F6ED ",
        }}
      >
        <Table
          rowClassName="table-row-gradient"
         key={`table-${tableKey}`}
          loading={tableLoading}
          columns={othercolumns.filter((col) => col.hidden === false)}
          dataSource={detailsListData}
          rowKey="id"
          scroll={{
            x: "max-content",
            y: "calc(80vh - 180px)",
          }}
          className="my-Table"
          style={{
            flex: 1,
            overflow: "auto",
          }}
        />
      </div>
    </Modal>
  );
};

export default DetailsModal;

